import React, { createContext, useState } from "react";
import axios from "axios";

export const AdminContext = createContext();

export const AdminProvider = (props) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseUrl = "https://sawaapi.space";

  async function getAdmin() {
    try {
      const token = localStorage.getItem("jwt");
      if (token) {
        const response = await axios.get(baseUrl + "/api/v1/admin", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setAdmin(response.data);
      }
    } catch (error) {
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }

  const login = async (credentials) => {
    try {
      const response = await axios.post(
        baseUrl + "/api/v1/admin/login",
        credentials
      );
      const { token, adminData } = response.data;
      localStorage.setItem("jwt", token);
      setAdmin(adminData);
      getAdmin();
      return response.data;
    } catch (error) {
      setError(error.response.data.message);
      throw error;
    }
  };

  const logout = async () => {
    try {
      localStorage.removeItem("jwt");
      setAdmin(null);
    } catch (error) {
      console.error("Failed to log out:", error);
    }
  };

  return (
    <AdminContext.Provider
      value={{
        admin,
        loading,
        error,
        getAdmin,
        login,
        logout,
      }}
    >
      {props.children}
    </AdminContext.Provider>
  );
};
